import MatchingPricingPlan from './MatchingPricingPlan.component';

export default MatchingPricingPlan;
